import { formatDistanceToNow } from 'date-fns';
import {
  createNewDate,
  filterConfigByTypes,
} from '../../../elements/Aggregation/aggregation-utils';
import { IssueDetails } from '../types/issues-types';
import {
  AggregationColumn,
  AggregationItem,
  ColumnType,
  IAggregationRow,
} from 'common-types';
import { snapshot } from 'valtio';
import IssuesExclusionsStore from '../stores/issues-exclusions-store';
import config from '../config/aggregations-columns.json';
const ROWS_LIMIT = 15;

export function generateAggregationsTable(selectedIssue: IssueDetails) {
  if (
    selectedIssue.aggregations.type &&
    config[selectedIssue.aggregations.type]
  ) {
    const table: IAggregationRow[] = [];

    const columns: AggregationColumn[] = filterConfigByTypes(
      config[selectedIssue.aggregations.type].columns,
      selectedIssue.aggregations.items,
    );
    const rowHeader: IAggregationRow = {
      value: [],
    };
    for (const column of columns) {
      rowHeader.value.push({
        value: column.header,
      });
    }

    table.push(rowHeader);
    const { selectedAggs } = snapshot(IssuesExclusionsStore);
    let filterRows: AggregationItem[] =
      selectedAggs.length > 0 ? selectedAggs : selectedIssue.aggregations.items;

    const limtedRows = filterRows.slice(0, ROWS_LIMIT);

    for (const item of limtedRows) {
      const rowData: IAggregationRow = {
        value: [],
      };
      for (const column of columns) {
        const value = item[column.key];
        const date = createNewDate(value);

        rowData.value.push({
          value:
            date && column.type === ColumnType.Date
              ? formatDistanceToNow(date) + ' ago'
              : !!!value
              ? ''
              : String(value),
          href: column.href && item[column.href] ? item[column.href] : null,
        });
      }
      table.push(rowData);
    }
    return table;
  }
  return null;
}
